module.exports = __webpack_public_path__ + "static/media/modifier.9f7c812b.png";